const IconTypes = {
  BRAND: 'BRAND',
  REGULAR: 'REGULAR',
  SOLID: 'SOLID'
};
export default Object.freeze(IconTypes);